<div class="layout-row align-end gap-2px responsive-column container m-b-20">
  <button mat-raised-button color="primary" [routerLink]="['edit']">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
  <button mat-raised-button color="warn" (click)="deleteAccountingClosure()" *LOSxHasPermission="'DELETE_GLCLOSURE'">
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

@if (glAccountClosure) {
  <div class="container">
    <mat-card>
      <mat-card-content>
        <div class="layout-row-wrap">
          <div class="flex-50 header">
            {{ 'labels.inputs.Office' | translate }}
          </div>
          <div class="flex-50">
            {{ glAccountClosure.officeName }}
          </div>
          <div class="flex-50 header">
            {{ 'labels.inputs.Closure Date' | translate }}
          </div>
          <div class="flex-50">
            {{ glAccountClosure.closingDate }}
          </div>
          <div class="flex-50 header">
            {{ 'labels.inputs.Closed By' | translate }}
          </div>
          <div class="flex-50">
            {{ glAccountClosure.createdByUsername }}
          </div>
          <div class="flex-50 header">
            {{ 'labels.inputs.Updated By' | translate }}
          </div>
          <div class="flex-50">
            {{ glAccountClosure.lastUpdatedByUsername }}
          </div>
          <div class="flex-50 header">
            {{ 'labels.inputs.Updated on' | translate }}
          </div>
          <div class="flex-50">
            {{ glAccountClosure.lastUpdatedDate }}
          </div>
          <div class="flex-50 header">
            {{ 'labels.inputs.Closure Creation Date' | translate }}
          </div>
          <div class="flex-50">
            {{ glAccountClosure.createdDate }}
          </div>
          <div class="flex-50 header">
            {{ 'labels.inputs.Comments' | translate }}
          </div>
          <div class="flex-50">
            {{ glAccountClosure.comments }}
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}
